import { Observable, ReplaySubject, Subject } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs';
import { UserCompanyInfo } from '../models/user-company-info.model';
import { UserPropertyInfo } from '../models/user-property-info.model';
import { PropertyFilter } from './property-filter';

export abstract class ProjectSwitching {
  public companiesList: Array<UserCompanyInfo> = [];
  public propertyFilter: PropertyFilter;
  protected _propertyFilter = new ReplaySubject<PropertyFilter>(1);
  public switchedFromMenu = new Subject();
  public $hasProjects = new ReplaySubject<boolean>(1);
  public projectUpdates$: ReplaySubject<void> = new ReplaySubject(1);

  public get $propertyFilter(): Observable<PropertyFilter> {
    return this._propertyFilter.asObservable().pipe(
      filter(_ => !!_),
      distinctUntilChanged(
        (a, b) => a.propertyId === b.propertyId && a.companyId === b.companyId
      )
    );
  }

  public setCompanies(companies: Array<UserCompanyInfo>): void {
    this.companiesList = companies;
  }

  public hasCompany(companyId: number): boolean {
    for (const company of this.companiesList) {
      if (company.companyId === companyId) {
        return true;
      }
    }
    return false;
  }

  public hasProject(id: number): boolean {
    for (const company of this.companiesList) {
      for (const property of company.properties) {
        if (property.propertyId === id) {
          return true;
        }
      }
    }
    return false;
  }

  // TODO verify and remove this if not using
  public checkIfProjectInSelectedCompany(propertyId: number): boolean {
    const companyID = this.propertyFilter.companyId;
    const company = this.companiesList.find(_ => _.companyId === companyID);
    if (!company) {
      return false;
    }
    for (const project of company.properties) {
      if (project.propertyId === propertyId) {
        return true;
      }
    }
    return false;
  }

  // TODO verify and remove this if note using
  public checkIfAllProjects(): boolean {
    return !this.propertyFilter.companyId && !this.propertyFilter.propertyId;
  }

  public getProject(propertyId: number | null): UserPropertyInfo | void {
    if (!propertyId) {
      return;
    }
    for (const company of this.companiesList) {
      for (const property of company.properties) {
        if (property.propertyId === propertyId) {
          return property;
        }
      }
    }
  }

  public getCompany(companyId: number | null): UserCompanyInfo | void {
    if (!companyId) {
      return;
    }
    for (const company of this.companiesList) {
      if (company.companyId === companyId) {
        return company;
      }
    }
  }

  public updateHasProjects(): 'there' | 'none' {
    for (const company of this.companiesList) {
      if (company.properties.length > 0) {
        this.$hasProjects.next(true);
        return 'there';
      }
    }
    this.$hasProjects.next(false);
    return 'none';
  }

  public resetState(): void {
    this.companiesList = [];
    this.propertyFilter = {
      propertyId: null,
      companyId: null,
      propertyTypeId: null
    };
    this._propertyFilter = new ReplaySubject(1);
    this.projectUpdates$ = new ReplaySubject(1);
    this.$hasProjects = new ReplaySubject<boolean>(1);
  }
}
